import {AfterViewInit, Directive} from "@angular/core";
import {DxiColumnComponent} from "devextreme-angular/ui/nested";
import {DocumentoPipe} from "../../core/pipes/documento.pipe";

@Directive({
  selector: "dxi-column[cpfCnpj]"
})
export class DxiColumnCpfCnpjDirective implements AfterViewInit {

  private readonly documentoPipe = new DocumentoPipe();

  constructor(private readonly dxiColumn: DxiColumnComponent) {
  }

  ngAfterViewInit(): void {
    if (this.dxiColumn){
      this.dxiColumn.customizeText = cellInfo => {
        const documentoFormatado = this.documentoPipe.transform(cellInfo.value);
        return documentoFormatado || cellInfo.valueText || "";
      };
    }
  }

}
